import { Component, OnInit } from '@angular/core';
import {DynamicDialogRef} from 'primeng/api';
import {DynamicDialogConfig} from 'primeng/api';
import { Router } from '@angular/router';
import { MessageService } from 'primeng/api';

@Component({
  selector: 'app-duplicate-license',
  templateUrl: './duplicate-license.component.html',
  styleUrls: ['./duplicate-license.component.css']
})
export class DuplicateLicenseComponent implements OnInit {
  selectedMid: string = "";
  recordList: any = [];
  constructor(private messageService: MessageService, public ref: DynamicDialogRef, public config: DynamicDialogConfig, public router: Router) { }

  ngOnInit() {
    this.recordList = this.config.data;
  }

  continueExsisting() {
    if(this.selectedMid != "") {
      this.ref.close(false);
      this.router.navigateByUrl("/viewmember/" + this.selectedMid);
    } else {
      this.messageService.add({ severity: 'info', summary: 'Business Details', detail: "Select Membership" });
    }
  }

  ignore() {
    this.ref.close(true);
  }

  close() {
    this.ref.close(false);
  }

  

}
